import AppFormInput from '../../../components/ui/AppFormInput';
import React, {useState, useRef} from 'react';
import {Link} from 'react-router-dom';
import {Toast} from 'primereact/toast';
import logo from '../../../assets/images/logo.png';
import apiClient from "../../../services/api-client";
import Cookies from 'js-cookie';
import {useHistory} from 'react-router-dom';
import AnimatedSuccessGIF from '../../../assets/images/check-green.gif';
import PhoneNumberInput from '../../../components/common/PhoneNumberInput';
// import '../../../assets/styles/auth-tokens.css';
// import '../../../assets/styles/auth-form.css';


const CreateNew = () => {
    const [formFields, setFormFields] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        nationalId: '',
        password: '',
        confirmPassword: '',
        otp: ''
    });

    const [formErrors, setFormErrors] = useState({});
    const [formStep, setFormStep] = useState(1);
    const history = useHistory();
    const toast = useRef(null);
    const [userId, setUserId] = useState('')
    const [registrationSuccess, setRegistrationSuccess] = useState(false)
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState('')

    const validateFormStep1 = () => {
        const errors = {};

        if (!formFields.firstName.trim()) {
            errors.firstName = 'First name is required';
        }

        if (!formFields.lastName.trim()) {
            errors.lastName = 'Last name is required';
        }

        // if (!formFields.email.trim()) {
        //   errors.email = 'Email is required';
        // } else if (!/\S+@\S+\.\S+/.test(formFields.email)) {
        //   errors.email = 'Invalid email address';
        // }

        if (!formFields.phoneNumber.trim()) {
            errors.phoneNumber = 'Phone number is required';
        }

        if (formFields.nationalId.trim() === '') {
            errors.nationalId = 'National ID number is required';
        }

        // else if (!/^\d{2}-.{5,}$/.test(formFields.nationalId)) {
        //   errors.nationalId = 'Enter a valid National ID Number (00-1234567A00)';
        // }

        return errors;
    };


    const validateFormStep2 = () => {
        const errors = {};

        if (!formFields.password.trim()) {
            errors.password = 'Password is required';
        } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(formFields.password)) {
            errors.password =
                'Password must meet the following criteria:\n\n' +
                '- At least 8 characters long\n' +
                '- Contain at least one letter (A-Z or a-z)\n' +
                '- Contain at least one number (0-9)\n' +
                '- Contain at least one special character (@, $, !, %, *, #, ?, or &)\n' +
                '\nFor example, valid passwords include:\n' +
                '- MyP@ssw0rd\n' +
                '- Secur!ty2023\n' +
                '- 1Am$tr0ng#P@ss';
        }


        if (formFields.password !== formFields.confirmPassword) {
            errors.confirmPassword = 'Passwords do not match';
        }

        if (!formFields.otp.trim()) {
            errors.otp = 'OTP is required';
        } else if (formFields.otp.length !== 6) {
            errors.otp = 'OTP must be 6 characters';
        }


        return errors;
    };


    const handleFieldChange = (e) => {
        const {name, value} = e.target;
        setFormFields((prevFormFields) => ({
            ...prevFormFields,
            [name]: value,
        }));
    };

    const handleSubmitData = () => {
        const errors = validateFormStep1();

        if (Object.keys(errors).length === 0) {

            setFormErrors({});
            registerUser()

        } else {
            setFormErrors(errors);
        }
    };

    const registerUser = async () => {
        const requestData = {
            accessToken: '',
            operation: 'create-user-profile',
            requestBody: {
                firstName: formFields.firstName.toUpperCase(),
                lastName: formFields.lastName.toUpperCase(),
                emailAddress: formFields.email,
                phoneNumber: formFields.phoneNumber,
                IDNumber: formFields.nationalId.replace(/[-\s]/g, ''),
                isActive: true,
                locked: false,
                enabled: true,
                userType: "CUSTOMER",
                userRole: 1,
            },
        };

        await fetch(process.env.REACT_APP_DOVESAPI + 'user/create/customer', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then(async (data) => {
                if (data.status === 'SUCCESS') {

                    setFormStep(2);
                    setUserId(data.responseBody.userId)

                    toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Check your email and phone, we sent you an OTP',
                            life: 4000
                        }
                    );
                } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: data.message,
                        life: 4000
                    });
                }
            })
            .catch((error) => {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry, exception occured, contact admin',
                    life: 4000
                });
            });
    };

    const setNewUserPassword = async () => {

        const payload = {
            "accessToken": "",
            "operation": "set-new-password",
            "requestBody": {
                "password": formFields.password
            }
        }

        await apiClient.post('user/setNewPassword/' + userId + '/' + formFields.otp, payload).then((data) => {

            if (data.data.status === "SUCCESS") {

                setRegistrationSuccess(true)
                setVisible(true)
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: data.data.message,
                    life: 4000
                });
            }
        })
            .catch((error) => {


                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: error,
                    life: 4000
                });

            });
    }

    const handlePhoneOtpOption = (value) => {
        setFormFields((prevFormFields) => ({
            ...prevFormFields,
            "phoneNumber": value,
        }));
    }
    const handleSetPassword = async () => {

        const errors = validateFormStep2();

        if (Object.keys(errors).length === 0) {
            await setNewUserPassword();
        } else {
            setFormErrors(errors);
        }
    };

    const stepCopy = {
        1: {title: 'Create your profile', subtitle: 'Tell us a bit about yourself to get started.'},
        2: {title: 'Verify & secure', subtitle: 'Enter the OTP we sent you and set a password.'},
    }[formStep];

    return (
        <>
            <Toast ref={toast}/>

            {
                !registrationSuccess ? (
                    <>

                        <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
                            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                                <div className="text-center mb-8 flex flex-col items-center">
                                    <Link to="/landing" className="flex items-center justify-center space-x-3 mb-6"><img
                                        className="h-10 w-auto" src={logo} alt="Doves"/><span
                                        className="bg-[#EBF5FF] text-[#135A9C] font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest">Self-Service Portal</span></Link>

                                    <h1 className="text-2xl font-extrabold text-slate-800 mt-2 tracking-tight">{stepCopy.title}</h1>
                                    <p className="mt-2 text-sm text-slate-500">{stepCopy.subtitle}</p>
                                </div>
                                <div
                                    className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100">
                                    <form name="myform">
                                        {formStep === 1 ? (
                                            <>
                                                <AppFormInput
                                                    type="text"
                                                    placeholder="First Name"
                                                    name="firstName"
                                                    value={formFields.firstName}
                                                    onChange={handleFieldChange} error={formErrors.firstName}
                                                />
                                                <AppFormInput
                                                    type="text"
                                                    placeholder="Surname"
                                                    name="lastName"
                                                    value={formFields.lastName}
                                                    onChange={handleFieldChange} error={formErrors.lastName}
                                                />
                                                <div className="form-control w-full space-y-1 mb-4">
                                                    <PhoneNumberInput
                                                        defaultCountry="zw"
                                                        value={formFields.phoneNumber}
                                                        onChange={handlePhoneOtpOption}
                                                        placeholder="712 345 678"
                                                    />
                                                    {formErrors.phoneNumber &&
                                                        <p className="text-error text-xs mt-1">{formErrors.phoneNumber}</p>}
                                                </div>
                                                <AppFormInput
                                                    type="text"
                                                    placeholder="National ID Number"
                                                    name="nationalId"
                                                    value={formFields.nationalId}
                                                    onChange={handleFieldChange} error={formErrors.nationalId}
                                                />
                                                <AppFormInput
                                                    type="email"
                                                    placeholder="Email Address"
                                                    name="email"
                                                    value={formFields.email}
                                                    onChange={handleFieldChange} error={formErrors.email}
                                                />

                                            </>
                                        ) : (
                                            <>
                                                <div className="form-control w-full space-y-1 mb-4">
                                                    <input type="text"
                                                           className="input input-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] focus:ring-2 focus:ring-[#135A9C]/20 text-center tracking-[0.5em] font-mono font-bold"
                                                           placeholder="OTP"
                                                           name="otp"
                                                           value={formFields.otp}
                                                           onChange={handleFieldChange}
                                                    />
                                                    {formErrors.otp &&
                                                        <p className="text-error text-xs mt-1">{formErrors.otp}</p>}
                                                </div>
                                                <AppFormInput
                                                    type="password"
                                                    placeholder="Password"
                                                    name="password"
                                                    value={formFields.password}
                                                    onChange={handleFieldChange}
                                                    error={formErrors.password}
                                                    hint="At least 8 characters, with an uppercase letter, a number and a special character."
                                                />
                                                <AppFormInput
                                                    type="password"
                                                    placeholder="Confirm Password"
                                                    name="confirmPassword"
                                                    value={formFields.confirmPassword}
                                                    onChange={handleFieldChange} error={formErrors.confirmPassword}
                                                />
                                            </>
                                        )}
                                        {formStep === 1 ? (
                                            <button
                                                type="button"
                                                className="btn w-full rounded-full font-bold mt-6 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none"
                                                onClick={handleSubmitData}
                                            >
                                                Next <i className="icofont-arrow-right"></i>
                                            </button>
                                        ) : (
                                            <button type="button"
                                                    className="btn w-full rounded-full font-bold mt-6 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none"
                                                    onClick={handleSetPassword}>
                                                Sign Up
                                            </button>
                                        )}
                                    </form>
                                    <p className="mt-8 pt-4 border-t border-slate-100 text-center text-xs text-slate-500">
                                        Already have an account?{' '}
                                        <Link className="font-bold text-[#135A9C] hover:underline ml-1" to="/signin">
                                            Sign In
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
                        <div className="sm:mx-auto sm:w-full sm:max-w-md bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100 flex flex-col items-center text-center">
                            <img className="w-24 h-24 mb-6" src={AnimatedSuccessGIF} alt=""/>
                            <h3 className="text-2xl font-extrabold text-slate-800 mb-2">Profile Created Successfully</h3>
                            <p className="text-slate-500 mb-6">You can now proceed to login</p>
                            <button
                                onClick={() => {
                                    setVisible(false)
                                    history.push("/signin")
                                }}
                                className="btn rounded-full font-bold bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none px-8"
                            >
                                <i className="pi pi-check-circle mr-1"/> Ok
                            </button>
                        </div>
                    </div>
                )}
        </>
    );
};

export default CreateNew;
